import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography, Grid, Chip } from '@mui/material';
import MainCard from '../../components/MainCard';
import { negativeSentimentColor, neutralSentimentColor, positiveSentimentColor, remainderSentimentColor } from '../../utils/constant';

const getSentimentColor = (sentiment) => {
    switch (sentiment) {
        case "positive":
            return positiveSentimentColor; // green
        case "negative":
            return negativeSentimentColor; // red
        case "neutral":
            return neutralSentimentColor; // gray
        default:
            return remainderSentimentColor; // fallback dark
    }
};


const formatSigned = (v) => {
    const n = Number(v ?? 0);
    if (!Number.isFinite(n) || n === 0) return "0"; // or "+0" if you prefer
    return n > 0 ? `+${n}` : `${n}`; // negative already has '-'
};



export default function TopThemeSentimentTable({ tableData }) {
    return (

        <>
            <Grid size={12}>
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid>
                        <Typography variant="h5">Top Themes by Sentiment</Typography>
                        <Typography variant="h6">Themes ranked by volume and ploarity</Typography>
                    </Grid>
                    <Grid />
                </Grid>
                <MainCard sx={{ mt: 2 }} content={false}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Theme</TableCell>
                                    <TableCell align="right">Top Keywords</TableCell>
                                    <TableCell align="right">Net Sentiment</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.categoryDiff.map((row) => (
                                    <TableRow
                                        key={row.category}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.category}
                                        </TableCell>
                                        <TableCell align="right">{row?.keywords?.slice(0, 3).map((el) => {
                                            return <p style={{
                                                margin: "0"
                                            }}>{el?.keyword}</p>
                                        })}</TableCell>
                                        <TableCell align="right">

                                            <Chip label={formatSigned(row.changePercent)} size="small" style={{ textTransform: 'capitalize' }} sx={{
                                                backgroundColor: getSentimentColor(row.changePercent),
                                                color: "white",
                                                borderRadius: "48px"
                                            }} />
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </MainCard>
            </Grid>
        </>
    );
}